import { Component, Input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginComponent } from '../login/login.component';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-firm-registered',
  templateUrl: './firm-registered.component.html',
  styleUrl: './firm-registered.component.scss',
  standalone: false
})
export class FirmRegisteredComponent {
  isLoading: boolean = false;
  mobileMenuOpen = false;
  searchQuery: any;
  firms: any;
  openEventIdx: number | null = null;
  tableColumns: any;
  listData: MatTableDataSource<any> = new MatTableDataSource([]);
  loading: boolean;
  private firmSet = new BehaviorSubject<any[]>([]);
  public firmData$ = this.firmSet.asObservable();
  pageLengths: number = 0
  pageIndexs: number = 0
  title: string;
  endPoint: string;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private notificationService: NotificationService,
    private http: HttpClient,


  ) {

  }

  ngOnInit(): void {
    this.title = history.state.title;
    if (this.title === "Registered Firms") {
      this.endPoint ="/api/gateway/public/firms";
      this.tableColumns = {
        no: 'sn',
        name: 'Name',
        category: 'Category',
        registrationNumber: 'Registration Number',
        postalAddress: 'Postal Address',
        termsOfRegistration: 'Terms Of Registration',
        firmType: 'Firm Type',
        action: '',
      };

    } else if (this.title === "Registered Professionals") {
      this.endPoint ="/api/gateway/public/professionals";
       this.tableColumns = {
        no: 'sn',
        fullName: 'FullName',
        profession: 'Profession',
        professionCategory: 'Profession Category',
        registrationNumber: 'Registration Number',
        status: 'status',
        action: '',
      };
    } else if (this.title === "Registered Projects") {
      this.endPoint ="/api/gateway/public/projects";
       this.tableColumns = {
        no: 'sn',
        name: 'Project Name',
        category: 'Project Category',
        address: 'Address',
        natureOfProject: 'Nature Of Project',
        buildingPermitNumber: 'Building Permit Number',
        action: '',
      };
    }

    this.fetchFirms();

  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  openLoginModal(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '500px', // Set a reasonable width for the modal
      // You can pass data to the modal using the `data` property:
      // data: { someInitialValue: 'hello' }
    });
  }

  navigateToRegistration(): void {
    this.router.navigate(['registration']);
  }

  openEvent() {
    this.router.navigate(['events']);
  }

  onPageChanged(event: { pageIndex: number, pageSize: number }) {
    this.fetchFirms(event.pageIndex, event.pageSize);
  }

  async fetchFirms(pageIndex: number = 0, pageSize: number = 10) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    // Include pagination as query params expected by the API (page, size)
    const params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('size', pageSize.toString());

    this.isLoading = true;
    try {
      const response = await firstValueFrom(
        this.http.get<any>(
          environment.SERVER_URL + this.endPoint,
          { headers, params }
        )
      );

      const pageData = response?.data;
      this.firms = pageData?.content || [];
      this.listData.data = this.firms;
      this.firmSet.next(this.firms);

      // Store pagination meta so MatPaginator (or your UI) can reflect server values
      this.pageIndexs = typeof pageData?.number === 'number' ? pageData.number : pageIndex;
      this.pageLengths = typeof pageData?.totalElements === 'number' ? pageData.totalElements : this.firms.length;

      return this.firms;
    } catch (error) {
      console.error('Failed to fetch firms', error);
      return null;
    } finally {
      this.isLoading = false;
    }
  }

}
